import React, { useEffect, useState } from "react";

import Swal from "sweetalert2"
import { HiSave } from "react-icons/hi";
import { CSVLink } from "react-csv";

import '../../styles/pacientesPendientes.css'
import '../../styles/table.css'

/**
 * Servicios
 */
//Importar el espacio de almacenamiento de base de datos firestore
import { pacientesStore, logCollection } from '../../firebase/config';

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaName, getUnidadHospitalariaValue } from '../../objects/unidadHospitalaria';

/**
 * Componentes
 */
//Componente que muestra el encabezado de una sección del site
import EncabezadoSeccion from "./encabezadoSeccion";
//Componente que muestra al usuario que se esta procesando la información del servicio
import Loader from "./loader";
//Componente que muestra la información general de un logcard
import LogCard from "./logCard";
//Componente que indica al usuario que no se obtuvo información con sus parámetros de búsqueda
import SinResultados from "./sinResultados";

/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
import { descrifrar, quitarAcentos } from '../../utils/functions';

/**
 * Componente que contiene el listado de logs registrados durante el día
 * @param {Object} param0 Recibe la información de la sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const LogsSection = ({nomHospital,userLevel,uhList,name}) => {

    //Estado que indica la cantidad de logs con disponibles en el sistema
    const [cantidadLogs,setCantidadLogs] = useState(0)
    //Estado que indica si se hay pacientes que mostrar
    const [hayResultados, setHayResultados] = useState(false)
    //Estado que indica si el log se mostrara de manera colapsada
    //const [isCollapsed,setIsCollapsed] = useState(true)
    //Estado que indica que se esta solicitando información al servicio
    const [isLoader,setIsLoader] = useState(false)
    //Estado que almacena los resultados de la búsqueda de logs según el parámetros requerido por el usuario
    const [logsAmostrarList,setLogsAmostrarList] = useState([])
    //Estado que almacena el log que se desea conocer sus detalles
    //const [logSelected,setLogSelected] = useState({})
    //Estado que almacena el titulo del detalle de log
    //const [logTitle, setLogTitle] = useState("")
    //Estado que almacena los logs obtenidos desde la base de datos en una lista
    const [logsList,setLogsList] = useState([])
    //Estado que indica si se muestra la opción para limpiar la búsqueda
    //const [seMuestra,setSeMuestra] = useState(true)
    //Estado que almacena el parametro de búsqueda para el muestreo de logs (si se encuentra vacio se consideran toda la lista de logs del día)
    const [valorBusqueda,setValorBusqueda] = useState("")

    //Estado que indica la fecha inicial del rango deseado
    const [initialDay,setInitialDay] = useState("")
    //Estado que indica la fecha final del rango deseado
    const [finalDay, setFinalDay] = useState("")
    //Estado que indica la fecha del dia actual
    const [today, setToday] = useState(new Date())
    const [resumen, setResumen] = useState([])

    
    useEffect(()=>{
        //document.getElementById('log-viewer').style.display='none'
        setValorBusqueda("")
        setIsLoader(true)
        if(initialDay && finalDay){
            //let date = new Date()
            //let today = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
            let inicial = initialDay.split('-')
            let final = finalDay.split('-')
            let todos = []
            let excluidos = []
            pacientesStore.collection(logCollection).where("date",">=",inicial[0]+"-"+parseInt(inicial[1])+"-"+inicial[2])
            .onSnapshot(snap => {
                const logs = []
                snap.forEach(doc => {
                    let data = doc.data()
                    let dateLog = data.date
                    if(parseInt(final[1]) >= parseInt(dateLog.split('-')[1])){
                        if(parseInt(final[1]) === parseInt(dateLog.split('-')[1])){
                            if(parseInt(final[2]) >= parseInt(dateLog.split('-')[2])){
                                logs.push({ id: doc.id, ...doc.data() })
                            }
                            else{
                                if(parseInt(dateLog.split('-')[0]) < parseInt(final[0])){
                                    logs.push({ id: doc.id, ...doc.data() })
                                }
                                else{
                                    excluidos.push({ id: doc.id, ...doc.data() })
                                }
                            }
                        }
                        else{
                            logs.push({ id: doc.id, ...doc.data() })
                        }
                    }
                    else{
                        if(parseInt(dateLog.split('-')[0]) < parseInt(final[0])){
                            logs.push({ id: doc.id, ...doc.data() })
                        }
                        else{
                            excluidos.push({ id: doc.id, ...doc.data() })
                        }
                    }
                    todos.push({ id: doc.id, ...doc.data() })
                    // let mesActual = date.getMonth() + 1 
                    // if(dateLog.split('-')[2].toString() === date.getDate().toString() &&
                    // mesActual.toString() === dateLog.split('-')[1].toString() &&
                    // date.getFullYear().toString() === dateLog.split('-')[0].toString()){
                    //     logs.push({ id: doc.id, ...doc.data() })
                    // }
                })

                setIsLoader(false)
                setLogsList(logs)
            },(error)=>{
                setIsLoader(false)
                setLogsList([])
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error,
                  })
            })
        }
    },[initialDay,finalDay])

    useEffect(()=>{
        if(logsList.length > 0){//Verificar si existen logs del día actual
            if(valorBusqueda){//Se desea realizar búsqueda de un log específico
                let resultadoBusqueda = []
                logsList.forEach(
                    log => {
                        //Obtención del nombre de la unidad hospitalaria del paciente
                        let uhName = getUnidadHospitalariaValue(log.paciente.UnidadHospitalaria)

                        //Obtención del nombre del paciente
                        let patientname = log.paciente.patientname
                        if(!patientname){//Si el paciente no tiene registrado nombre se le asignará No Disponible
                            patientname = "No Disponible"
                        }

                        if(userLevel !== "superuser"){//Se verifica si el usuario no tiene privilegios de superuser
                            if(getUnidadHospitalariaName(descrifrar(nomHospital).toString(),uhList) === getUnidadHospitalariaName(uhName,uhList)){
                                if(log.paciente.NumeroDePaciente.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || uhName.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || log.paciente.NumeroTelefono.includes(valorBusqueda)
                                    || quitarAcentos(patientname.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(log.action.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(log.username.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))){//Se realiza la búsqueda de coincidencias en los campos uhName, número de teléfono y numero de paciente
                                        resultadoBusqueda.push(log)
                                    }
                            }
                        }
                        else{//Usuario con privilegios superuser
                            if(log.paciente.NumeroDePaciente.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || uhName.toUpperCase().includes(valorBusqueda.toUpperCase())
                                    || log.paciente.NumeroTelefono.includes(valorBusqueda)
                                    || quitarAcentos(patientname.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(log.action.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))
                                    || quitarAcentos(log.username.toUpperCase()).includes(quitarAcentos(valorBusqueda.toUpperCase()))){//Se realiza la búsqueda de coincidencias en los campos uhName, número de teléfono y numero de paciente
                                        resultadoBusqueda.push(log)
                                    }
                        }
                    }
                )

                if(resultadoBusqueda.length > 0){//Se encontraron resultados a la búsqueda deseada
                    setHayResultados(true)
                    //Ordenar los resultados por la fecha de manera descente
                    resultadoBusqueda.sort(function(x, y) {
                        var firstDate = new Date(x.date+" "+x.time),
                          SecondDate = new Date(y.date+" "+y.time);
                          
                        if (firstDate > SecondDate) return -1;
                        if (firstDate < SecondDate) return 1;
                        return 0;
                      });
                    setCantidadLogs(resultadoBusqueda.length)
                }
                else{//La búsqueda no obtuvo ningún paciente como resultado
                    setHayResultados(false)
                    setCantidadLogs(0)
                }
                setLogsAmostrarList(resultadoBusqueda)
            }
            else{//Se muestran todos los logs disponibles si cumplen con los requerimientos de permiso
                let logValidos = 0
                let logsUnidad = []
                let numerosAtencion = []
                logsList.forEach(
                    log => {
                        if(userLevel !== "superuser"){
                            let uhName = getUnidadHospitalariaValue(log.paciente.UnidadHospitalaria)
                            if(getUnidadHospitalariaName(descrifrar(nomHospital).toString(),uhList) === getUnidadHospitalariaName(uhName,uhList)){
                                logValidos = logValidos + 1
                                numerosAtencion.push(log.paciente.NumeroDePaciente)
                                logsUnidad.push(log)
                            }
                        }
                        else{
                            logValidos = logValidos + 1
                            numerosAtencion.push(log.paciente.NumeroDePaciente)
                            logsUnidad.push(log)
                        }
                    }
                )

                if(logValidos > 0){//Se verifica si existen logs que pertenezcan a la unidad hospitalaria requerida
                    //Ordenar los losg por la fecha de manera descendente
                    logsList.sort(function(x, y) {
                        var firstDate = new Date(x.date+" "+x.time),
                          SecondDate = new Date(y.date+" "+y.time);
                          
                        if (firstDate > SecondDate) return -1;
                        if (firstDate < SecondDate) return 1;
                        return 0;
                      });
                    for(var i = numerosAtencion.length -1; i >=0; i--){
                        if(numerosAtencion.indexOf(numerosAtencion[i]) !== i) numerosAtencion.splice(i,1);
                      }

                    let logsResumen = []
                    for(let i = 0; i<numerosAtencion.length; i++){
                        let unidad = ""
                        let nombre = ""
                        let nacimiento = ""
                        let momentos = 0
                        let salida = 0
                        let recuperacion = 0
                        let especial = 0
                        let especialInterno = 0
                        let especialExterno = 0
                        let quirofano = 0
                        let ambulatorio = 0
                        let cancelacion = 0
                        let desdeRecuperacion = 0
                        let desdeQuirofano = 0
                        logsUnidad.forEach(
                            log => {
                                if(log.paciente.NumeroDePaciente === numerosAtencion[i]){
                                    unidad = log.paciente.UnidadHospitalaria
                                    nombre = log.paciente.patientname
                                    nacimiento = log.paciente.birthdate
                                    momentos = momentos + 1
                                    if(log.action === "Report status to Salida"){
                                        salida = salida + 1
                                    }
                                    else{
                                        if(log.action === "Report status to Recuperacion"){
                                            recuperacion = recuperacion + 1
                                        }
                                        else{
                                            if(log.action === "Report status to Especial"){
                                                if(log.IsInOperacion){
                                                    especialInterno = especialInterno + 1
                                                }
                                                else{
                                                    console.log(log)
                                                    especialExterno = especialExterno + 1
                                                }
                                                especial = especial + 1
                                            }
                                            else{
                                                if(log.action === "Report status to Quirofano"){
                                                    quirofano = quirofano + 1
                                                }
                                                else{
                                                    if(log.action === "Report status to Ambulatorio Alta"){
                                                        ambulatorio = ambulatorio + 1
                                                    }
                                                    else{
                                                        if(log.action === "Report status to Cancelación"){
                                                            cancelacion = cancelacion + 1
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if(log.lastEstatus === "Recuperación"){
                                        desdeRecuperacion = desdeRecuperacion + 1
                                    }
                                    else{
                                        desdeQuirofano = desdeQuirofano + 1
                                    }
                                }
                            }
                        )
                        let tipo = "Row"
                        if (i % 2 !== 0){
                            tipo = "RowImpar"
                        }
                        else{
                            tipo = "Row"
                        }
                        logsResumen.push({
                            'unidad' : unidad,
                            'hospitalizacion' : numerosAtencion[i],
                            'paciente' : nombre,
                            'nacimiento' : nacimiento.toString().split(' ')[0],
                            'momentos' : momentos,
                            'salida' : salida,
                            'recuperacion' : recuperacion,
                            'especial' : especial,
                            'quirofano' : quirofano,
                            'ambulatorio' : ambulatorio,
                            'cancelacion' : cancelacion,
                            'desdeQuirofano' : desdeQuirofano,
                            'desdeRecuperacion' : desdeRecuperacion,
                            'especialInterno' : especialInterno,
                            'especialExterno' : especialExterno,
                            'tipo' : tipo
                        })
                    }
                    logsResumen.push({
                        'unidad' : "",
                        'hospitalizacion' : "",
                        'paciente' : "",
                        'nacimiento' : "",
                        'momentos' : "",
                        'salida' : "",
                        'recuperacion' : "",
                        'especial' : "",
                        'quirofano' : "",
                        'ambulatorio' : "",
                        'cancelacion' : "",
                        'desdeQuirofano' : "Total Momentos",
                        'desdeRecuperacion' : logsUnidad.length,
                        'especialInterno' : "",
                        'especialExterno' : "",
                        'tipo' : "Row"
                    })

                    setResumen(logsResumen)
                    setCantidadLogs(logValidos)
                    setLogsAmostrarList(logsList)
                    setHayResultados(true)
                }
                else{//No se encontraron logs pertenecientes a la unidad hospitalaria
                    setLogsAmostrarList([])
                    setResumen([])
                    setHayResultados(false)
                    setCantidadLogs(0)
                }
            }
        }
        else{//No hay logs por mostrar
            setLogsAmostrarList([])
            setResumen([])
            setCantidadLogs(0)
            setHayResultados(false)
        }

    },[logsList,valorBusqueda,userLevel,nomHospital,uhList])

    useEffect(()=>{
        let today = new Date()
        setInitialDay(today.getFullYear()+"-"+(today.getMonth()+1).toString().padStart(2,"0")+"-"+today.getDate().toString().padStart(2,"0"))
        setFinalDay(today.getFullYear()+"-"+(today.getMonth()+1).toString().padStart(2,"0")+"-"+today.getDate().toString().padStart(2,"0"))
        setToday(today.getFullYear()+"-"+(today.getMonth()+1).toString().padStart(2,"0")+"-"+today.getDate().toString().padStart(2,"0"))
    },[])

    const onInitialDayChange = e => {
        setInitialDay(e.target.value)
      };

    const onFinalDayChange = e => {
        setFinalDay(e.target.value)
      };

      const headers = [
        { label: "Unidad Hospitalaria", key: "unidad"},
        { label: "Número de hospitalización", key: "hospitalizacion"},
        { label: "Nombre del paciente", key: "paciente"},
        { label: "Fecha de Nacimiento", key: "nacimiento"},
        { label: "Quirófano", key: "quirofano"},
        { label: "Recuperación", key: "recuperacion"},
        { label: "Salida", key: "salida"},
        { label: "Ambulatorio", key: "ambulatorio"},
        { label: "Especial Interno", key: "especialInterno" },
        { label: "Especial Externo", key: "especialExterno"},
        { label: "Cancelación", key: "cancelacion"},
        { label: "Momentos informados", key: "momentos"},
        { label: "Desde Quirófano", key: "desdeQuirofano"},
        { label: "Desde Recuperación", key: "desdeRecuperacion"},
      ];

      const csvreport = {
        data: resumen,
        headers: headers,
        filename: 'Momentos Reportados del ' + initialDay  + ' al ' + finalDay + '.csv',
    };

    const styleActive = { color: "white", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}

    return (
        <>
            <section className='seccion_pacientes_pendientes'>
                <div className='cuerpoEncabezado'>
                    <EncabezadoSeccion tituloInicial={"Registro de actividad"} tituloFinal={" realizada durante el periodo:"} imgSource={"https://hospitalesmac.com/img/icono_16.png"} cantidad={cantidadLogs}/>
                    <div className='firstfiltercont'>
                            <span className='fecha'>Inicio:</span>
                            <input
                                type="date"
                                onChange={onInitialDayChange}
                                value={initialDay}
                                max={today}
                            />
                            <span className='fecha'>Fin:</span>
                            <input
                                type="date"
                                onChange={onFinalDayChange}
                                value={finalDay}
                                min={initialDay}
                            />
                    </div>
                </div>
                <div className='itemservespCont'>
                    {
                        isLoader ?
                            <Loader/>
                        : 
                            hayResultados ?
                                <>
                                    {
                                        logsAmostrarList.map(log => 
                                            <LogCard key={log.id} log={log} userLevel={userLevel} uhList={uhList} nomHospitalUser={nomHospital}
                                            />
                                        )
                                    }
                                    <br/>
                                    <div className="Table">
                                        <div className="Heading">
                                            <div className="Cell">
                                                <p>Unidad Hospitalaria</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Número de hospitalización</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Nombre del paciente</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Fecha de Nacimiento</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Quirófano</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Recuperación</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Salida</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Ambulatorio</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Especial Interno</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Especial Externo</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Cancelación</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Momentos informados</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Desde Quirófano</p>
                                            </div>
                                            <div className="Cell">
                                                <p>Desde Recuperación</p>
                                            </div>
                                        </div>
                                        {
                                            resumen.map(event => 
                                                <div className={event.tipo} key={event.hospitalizacion}>
                                                    <div className="Cell">
                                                        <p>{event.unidad}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.hospitalizacion}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.paciente}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.nacimiento}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.quirofano}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.recuperacion}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.salida}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.ambulatorio}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.especialInterno}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.especialExterno}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.cancelacion}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.momentos}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.desdeQuirofano}</p>
                                                    </div>
                                                    <div className="Cell">
                                                        <p>{event.desdeRecuperacion}</p>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                </>
                            :
                                <SinResultados/>
                    }
                </div>
                <br />
                {/* <div className='itemservespCont' id="log-viewer">
                    <h1 className='itemblogTitle'>{logTitle} <span className='salir' onClick={handleCerrarClick()}>X</span></h1>
                    <JSONViewer src={logSelected} collapsed={isCollapsed}/>
                </div> */}
                <CSVLink {...csvreport} className="btn-flotanteExportMedicos" title="Exportar a CSV" alt="Exportar"><HiSave style={styleActive}/></CSVLink>

            </section>
        </>
    )
}

export default LogsSection;